<template>
  <div class="container">
    <MainMenu v-bind:class="{ floating: this.$route.path == '/' }" @pullSheetClick='showPullSheet = !showPullSheet, showAccount = false' @accountClick='showAccount = !showAccount, showPullSheet = false' />
      <div class="content" @click="showAccount = false, showPullSheet = false"><router-view></router-view></div>
      <PullSheet v-bind:class="{ floating: this.$route.path == '/' }" v-bind:showing="showPullSheet" v-on:itemAdded="pullSheetAdded" />
      <Account v-bind:class="{ floating: this.$route.path == '/' }" v-bind:showing="showAccount" />
    <MainFooter />
  </div>
</template>

<script>
import MainMenu from './MainMenu'
import MainFooter from './MainFooter'
import PullSheet from './PullSheet'
import Account from './Account'
export default {
  name: 'Site',
  components: {
    MainMenu,
    MainFooter,
    PullSheet,
    Account
  },
  data () {
    return {
      showPullSheet: false,
      showAccount: false
    }
  },
  methods: {
    pullSheetAdded: function () {
      this.showPullSheet = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
h1, h2 {
  font-weight: normal;
}

div.content {
}

</style>



// WEBPACK FOOTER //
// Site.vue?7ec88e5a